import get from 'lodash/get';
import find from 'lodash/find';
import { VERTICAL_NAMES } from '../common/constants/common';
import { origins } from '../common/constants/origins';

export const pickGeolocationFilters = filters => ({
  region: get(filters, 'region'),
  city: get(filters, 'city'),
  cityArea: get(filters, 'city_area'),
});

export const hasGeolocationFilter = filters => {
  const { region, city, city_area: cityArea } = pickGeolocationFilters(filters);

  return region || city || cityArea;
};

export function getGeoId(adsFiltersArray, stateGeoId, ignoreGeoId) {
  if (ignoreGeoId) {
    return null;
  }

  // Geo filter id given by response with auto filters
  // Normally when comming from a SEO url "/casa-comunidad-madrid"
  const geoIdFilter = find(adsFiltersArray, adsFilter => adsFilter.name === 'geo_id');

  return get(geoIdFilter, 'value') || stateGeoId;
}

/**
 * In order to match with the PHP filters count version
 * we need to count couples of "range filter" as one filter.
 * @example
 *  - If "salary_min" and "salary_max" are active they count as 1 applied filter, not 2
 *
 * 1. replace (_max / _min) string from active filter keys
 * 2. Remove array duplicates
 * 3. Get the array length
 */
export function countAppliedFilters(appliedFilters) {
  if (!appliedFilters) {
    return 0;
  }

  return Object.keys(appliedFilters)
    .map(item => item.replace(/(_max)|(_min)/, ''))
    .filter((elem, index, self) => index === self.indexOf(elem)).length;
}

/**
 * When comming from Email Alerts (retention) in Jobs vertical
 * we should not show AFS for ES and US countries.
 * This is due to a Google petition, otherwise we could be banned.
 *
 * @see https://jira.services/browse/PROD-514
 */
export function shouldShowAFSCommingFromAlert(
  isRetention,
  origin,
  currentCountryCode,
  currentVerticalName
) {
  const notAllowedCountries = ['es', 'us'];
  const notAllowedOrigins = [
    origins.ORIGIN_ALERT_MORELIKETHIS,
    origins.ORIGIN_ALERT_MORELIKETHIS2,
    origins.ORIGIN_ALERT_NORMAL,
    origins.ORIGIN_ALERT_NORMAL2,
    origins.ORIGIN_ALERT_DIGEST_DECREASE_PRICE,
  ];

  return !(
    isRetention &&
    currentVerticalName === VERTICAL_NAMES.jobs &&
    notAllowedOrigins.indexOf(origin) > -1 &&
    notAllowedCountries.indexOf(currentCountryCode) > -1
  );
}



// WEBPACK FOOTER //
// ./app/Serp/utils.js